'use client';

import { changeLanguage } from '@/lib/i18n';
import { CANVAS_LOCALE_OPTIONS, normalizeLocale } from '@/lib/i18n/resources';
import { cn } from '@/lib/utils';
import { useI18n } from '@/providers/i18n';

/** 登录、注册、分享页顶栏的画布语言切换。切换后刷新，让 Clerk 文案与 SSR 语言一起更新。 */
export function CanvasLocaleSwitch({ className }: { className?: string }) {
  const { i18n } = useI18n();
  const current = normalizeLocale(i18n.language);

  const apply = (code: string) => {
    if (current === code) return;
    try {
      void changeLanguage(code);
    } catch {}
    try {
      window.location.reload();
    } catch {}
  };

  return (
    <div className={cn('flex items-center gap-3', className)}>
      {CANVAS_LOCALE_OPTIONS.map((opt) => (
        <button
          key={opt.code}
          type="button"
          className={cn(
            'text-sm',
            current === opt.code ? 'text-foreground' : 'text-muted-foreground hover:text-foreground'
          )}
          onClick={() => apply(opt.code)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
